import { whatIfInnerSelector, whatIfOptionsOrDefaultSelector } from '../../WhatIfsSelector';

export const spouseYearlyCostSelector = (state, props) =>
  whatIfInnerSelector(state, props).SpouseYearlyCost;
export const principalYearlyCostSelector = (state, props) =>
  whatIfInnerSelector(state, props).PrincipalYearlyCost;

export const principalNameSelector = (state, props) =>
  whatIfOptionsOrDefaultSelector(state, props).PrincipalName;

export const spouseNameSelector = (state, props) =>
  whatIfOptionsOrDefaultSelector(state, props).SpouseName;

export const hasSpouseSelector = (state, props) =>
  !!whatIfOptionsOrDefaultSelector(state, props).SpouseName;
